export default "__VITE_ASSET__yfw0$PQd__"